var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container verticalCentred" },
    [
      _vm.loading ? _c("loading") : _vm._e(),
      _vm._v(" "),
      !_vm.consent
        ? _c("div", [
            _c("div", { staticClass: "form-row justify-content-center" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-12 mb-3 center" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: {
                      click: function($event) {
                        return _vm.checkConsent()
                      }
                    }
                  },
                  [_vm._v("\n          accetta\n        ")]
                )
              ])
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 mb-3" }, [
      _c("h4", { staticClass: "mb-4 center text-red sans-serifBold" }, [
        _c("strong", [
          _vm._v(
            "Per poter proseguire é necessario prendere visione\n            dell'informativa"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c0a1213a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0a1213a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/confirm/index.vue
// module id = null
// module chunks = 